export enum EnvironmentName {
  Development = 'Development',
  Staging = 'Staging',
  Production = 'Production',
}
